// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page-container {
    min-height: 100vh;
    background-color: #f9fafb;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 1.5rem;
}

.auth-page-header {
    max-width: 28rem;
    margin: 0 auto;
    width: 100%;
}

.auth-page-title {
    margin-top: 1.5rem;
    text-align: center;
    font-size: 1.875rem;
    font-weight: 800;
    color: #1f2937;
}

.auth-page-subtitle {
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.875rem;
    color: #6b7280;
}

.auth-toggle-btn {
    font-weight: 500;
    color: #4f46e5;
    background: none;
    border: none;
    cursor: pointer;
}

.auth-toggle-btn:hover {
    color: #4338ca;
}

.auth-form-container {
    margin-top: 2rem;
    max-width: 28rem;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}

.auth-form-box {
    background-color: white;
    padding: 2rem 1rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
}

@media (min-width: 640px) {
    .auth-form-box {
        padding: 2rem 2.5rem;
    }
}

.auth-form-element {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.auth-form-group {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.auth-form-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
}

.auth-input-group {
    position: relative;
    display: flex;
    align-items: center;
}

.auth-input-icon {
    position: absolute;
    left: 0.75rem;
    display: flex;
    align-items: center;
    pointer-events: none;
}

.auth-icon {
    width: 1.25rem;
    height: 1.25rem;
    color: #9ca3af;
}

.auth-input {
    width: 95%;
    padding: 0.5rem 0.75rem 0.5rem 2.5rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #1f2937;
}

.auth-input:focus {
    outline: none;
    border-color: #4f46e5;
    box-shadow: 0 0 0 1px #4f46e5;
}

.auth-password-toggle {
    position: absolute;
    right: 0.75rem;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.auth-form-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.auth-remember-me {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.auth-remember-checkbox {
    width: 1rem;
    height: 1rem;
    border-radius: 0.25rem;
    border: 1px solid #d1d5db;
    color: #4f46e5;
}

.auth-remember-checkbox:checked {
    background-color: #4f46e5;
    border-color: #4f46e5;
}

.auth-remember-label {
    font-size: 0.875rem;
    color: #1f2937;
}

.auth-forgot-link {
    font-size: 0.875rem;
    font-weight: 500;
    color: #4f46e5;
    text-decoration: none;
}

.auth-forgot-link:hover {
    color: #4338ca;
}

.auth-submit-button {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.375rem;
    background-color: #4f46e5;
    color: white;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
}

.auth-submit-button:hover {
    background-color: #4338ca;
}

.auth-submit-button:focus {
    outline: none;
    box-shadow: 0 0 0 2px white, 0 0 0 4px #4f46e5;
}`, "",{"version":3,"sources":["webpack://./src/styles/AuthPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD","sourcesContent":[".auth-page-container {\n    min-height: 100vh;\n    background-color: #f9fafb;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 3rem 1.5rem;\n}\n\n.auth-page-header {\n    max-width: 28rem;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.auth-page-title {\n    margin-top: 1.5rem;\n    text-align: center;\n    font-size: 1.875rem;\n    font-weight: 800;\n    color: #1f2937;\n}\n\n.auth-page-subtitle {\n    margin-top: 0.5rem;\n    text-align: center;\n    font-size: 0.875rem;\n    color: #6b7280;\n}\n\n.auth-toggle-btn {\n    font-weight: 500;\n    color: #4f46e5;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.auth-toggle-btn:hover {\n    color: #4338ca;\n}\n\n.auth-form-container {\n    margin-top: 2rem;\n    max-width: 28rem;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n}\n\n.auth-form-box {\n    background-color: white;\n    padding: 2rem 1rem;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 0.5rem;\n}\n\n@media (min-width: 640px) {\n    .auth-form-box {\n        padding: 2rem 2.5rem;\n    }\n}\n\n.auth-form-element {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.auth-form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.auth-form-label {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #374151;\n}\n\n.auth-input-group {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.auth-input-icon {\n    position: absolute;\n    left: 0.75rem;\n    display: flex;\n    align-items: center;\n    pointer-events: none;\n}\n\n.auth-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n    color: #9ca3af;\n}\n\n.auth-input {\n    width: 95%;\n    padding: 0.5rem 0.75rem 0.5rem 2.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.375rem;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: #1f2937;\n}\n\n.auth-input:focus {\n    outline: none;\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 1px #4f46e5;\n}\n\n.auth-password-toggle {\n    position: absolute;\n    right: 0.75rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.auth-form-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.auth-remember-me {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.auth-remember-checkbox {\n    width: 1rem;\n    height: 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid #d1d5db;\n    color: #4f46e5;\n}\n\n.auth-remember-checkbox:checked {\n    background-color: #4f46e5;\n    border-color: #4f46e5;\n}\n\n.auth-remember-label {\n    font-size: 0.875rem;\n    color: #1f2937;\n}\n\n.auth-forgot-link {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #4f46e5;\n    text-decoration: none;\n}\n\n.auth-forgot-link:hover {\n    color: #4338ca;\n}\n\n.auth-submit-button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 0.375rem;\n    background-color: #4f46e5;\n    color: white;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.auth-submit-button:hover {\n    background-color: #4338ca;\n}\n\n.auth-submit-button:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px white, 0 0 0 4px #4f46e5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
